import React, { useState } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import { downloadCSV,convertToCSV } from "../../helpers";
import { Button } from "react-bootstrap";

const ExportCSVButton = ({ apiFn, processItem, filenamePrefix = "export", queryParams = {} }) => {
    const dispatch = useDispatch();
    const [isExporting, setIsExporting] = useState(false);
    const [exportProgress, setExportProgress] = useState(0);

    const exportCSV = async () => {
        try {
            setIsExporting(true);
            setExportProgress(0);
            const firstPageResult = await dispatch(
                apiFn({ ...queryParams, page: 1, limit: 1 })
            ).unwrap();

            const totalRecords = firstPageResult.pagination?.total || 0;
            if (totalRecords === 0) {
                alert("No data to export");
                return;
            }

            let allData = [];
            let currentExportPage = 1;
            const chunkSize = 100;
            let hasMoreData = true;

            while (hasMoreData) {
                try {
                    const result = await dispatch(
                        apiFn({ ...queryParams, page: currentExportPage, limit: chunkSize })
                    ).unwrap();

                    if (result.data?.length > 0) {
                        const processedChunk = result.data.map((item) =>
                            processItem(item)
                        );
                        allData = [...allData, ...processedChunk];

                        const progress = Math.round((allData.length / totalRecords) * 100);
                        setExportProgress(progress);

                        const { page, totalPages } = result.pagination || {};
                        hasMoreData = page < totalPages;
                        currentExportPage++;

                        await new Promise((resolve) => setTimeout(resolve, 100));
                    } else {
                        hasMoreData = false;
                    }
                } catch (error) {
                    console.error(`Error fetching page ${currentExportPage}:`, error);
                    hasMoreData = false;
                }
            }

            if (allData.length > 0) {
                const csvContent = convertToCSV(allData);
                const timestamp = moment().format('DD-MM-YYYY HH:mm:ss');
                const filename = `${filenamePrefix}_${timestamp}.csv`;

                downloadCSV(csvContent, filename);
                alert(`Export completed successfully! ${allData.length} records exported.`);
            } else {
                alert("No data was collected for export");
            }
        } catch (error) {
            console.error("Export failed:", error);
            alert(`Export failed: ${error.message || "Unknown error"}`);
        } finally {
            setIsExporting(false);
            setExportProgress(0);
        }
    };

    return (
        <Button
            variant="icon-button text-light"
            onClick={exportCSV}
            data-pr-tooltip={
                isExporting
                    ? `Exporting... ${exportProgress}%`
                    : "Export All Records to CSV"
            }
            disabled={isExporting}
        >
            {isExporting ? (
                <div className="d-flex align-items-center">
                    <i className="fa fa-spinner fa-spin" />
                    {exportProgress > 0 && (
                        <small className="ms-1">{exportProgress}%</small>
                    )}
                </div>
            ) : (
                <i className="fa fa-download" />
            )}
        </Button>
    );
};

export default ExportCSVButton;